"use strict";
export const ShopsMock = (mock) => {
  mock.onGet("/v7/client/users_all").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "account": "136720214790089",
            "guid": "user_cf94117f16cd4bf1976d7c0851c7c590",
            "model": "sub_account",
            "name": "\u738B\u6668"
          },
          {
            "account": "136720214790088",
            "guid": "user_f02bd70481664827af9f81efb98c5cfb",
            "model": "sub_account",
            "name": "\u6D69\u7136"
          },
          {
            "account": "136720214790079",
            "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
            "model": "sub_account",
            "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641"
          },
          {
            "account": "136720214790078",
            "guid": "user_fa8d381de4864dba87c903808170bb09",
            "model": "sub_account",
            "name": "\u5458\u5DE5783216520321650531525621563152152153621562326152"
          },
          {
            "account": "136720214790077",
            "guid": "user_4272f0df416146ff9f255067afd8d03a",
            "model": "sub_account",
            "name": "\u5458\u5DE5772321321322312115605615030330020320323220312320"
          },
          {
            "account": "136720214790076",
            "guid": "user_44d6240560e84a9784a171d8b1bd58a9",
            "model": "sub_account",
            "name": "\u5458\u5DE576"
          },
          {
            "account": "136720214790075",
            "guid": "user_aa16dd48251a4176bd9b819d4b36dcbf",
            "model": "sub_account",
            "name": "\u5458\u5DE575"
          },
          {
            "account": "136720214790073",
            "guid": "user_62c070277d1d4275ac81e904591f3c5d",
            "model": "sub_account",
            "name": "\u5458\u5DE573"
          },
          {
            "account": "136720214790071",
            "guid": "user_76289cedef12419baf324b421e36ca66",
            "model": "sub_account",
            "name": "\u5458\u5DE571"
          },
          {
            "account": "136720214790070",
            "guid": "user_c408272d46d141acb35c228223781828",
            "model": "sub_account",
            "name": "\u5458\u5DE570"
          }
        ]
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 57,
        "size": 10
      }
    };
    return [200, response];
  });
  mock.onGet("/V7/client/shop_owners").reply((config) => {
    let response = {
      "model": "data.set",
      "datas": [
        {
          "model": "sub_account",
          "guid": "user_cf94117f16cd4bf1976d7c0851c7c590",
          "name": "\u738B\u6668",
          "account": "136720214790089"
        },
        {
          "account": "136720214790078",
          "guid": "user_fa8d381de4864dba87c903808170bb09",
          "model": "sub_account",
          "name": "\u5458\u5DE5783216520321650531525621563152152153621562326152"
        },
        {
          "account": "136720214790077",
          "guid": "user_4272f0df416146ff9f255067afd8d03a",
          "model": "sub_account",
          "name": "\u5458\u5DE5772321321322312115605615030330020320323220312320"
        }
      ],
      "total": 3
    };
    return [200, response];
  });
};
